import Link from 'next/link';
import React, { CSSProperties, HTMLAttributeAnchorTarget, ReactNode } from 'react';
import styled from 'styled-components';

import { isWebView } from '@/utils/mobile/RNPlugins';

interface Props {
  href: string;
  children: ReactNode;
  onClickNavigateToScreen?: () => void;
  target?: HTMLAttributeAnchorTarget;
  style?: CSSProperties;
  wrapperStyle?: CSSProperties;
}
const LinkTag = ({ href, target = '_self', children, style, onClickNavigateToScreen, wrapperStyle }: Props) => {
  return isWebView() ? (
    <Wrapper role='button' onClick={onClickNavigateToScreen} style={wrapperStyle}>
      {children}
    </Wrapper>
  ) : (
    <Link href={href} style={style}>
      <a target={target} style={style}>
        {children}
      </a>
    </Link>
  );
};

export default LinkTag;

const Wrapper = styled.div``;
